import { PagedResponse } from '@bo-client/shared/models/paged-response.model';

/** Vorlage oder veröffentlicht – siehe `docs/technical/components/app-news.md`. */
export type AppNewsStatus = 'DRAFT' | 'PUBLISHED';

export interface AppNewsModel {
  id: number;
  title: string;
  /** Vom Server bereinigtes HTML (nur Text, Formatierungen und Links). */
  description: string;
  status: AppNewsStatus;
  /** ISO-Zeitstempel der Veröffentlichung; `null` bei Vorlagen. */
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Verwaltungsliste: alle Vorlagen vollständig (zuletzt angelegte zuerst) und eine Seite der
 * veröffentlichten (zuletzt veröffentlichte zuerst).
 */
export interface AppNewsAdminModel {
  drafts: AppNewsModel[];
  published: PagedResponse<AppNewsModel>;
}

export interface AppNewsSaveModel {
  title: string;
  description: string;
}

export interface AppNewsLatestModel {
  latestPublishedAt: string | null;
}

/** Anzahl Neuigkeiten im automatisch geöffneten Modal. */
export const APP_NEWS_STARTUP_SIZE = 1;

/** Anzahl Neuigkeiten im Modal aus dem Benutzermenü. */
export const APP_NEWS_MENU_SIZE = 10;

/**
 * Seitengröße der veröffentlichten Neuigkeiten in der Verwaltung; weitere lädt der Button „Weitere
 * Neuigkeiten laden“. Vorlagen kommen immer vollständig.
 */
export const APP_NEWS_ADMIN_PAGE_SIZE = 20;

/** Höchstlänge des Titels (Spalte `hap_app_news.title`). */
export const APP_NEWS_TITLE_MAX_LENGTH = 255;

/**
 * Quill-Formate des Neuigkeiten-Editors: genau die Toolbar von `app-quill-form-input`, ohne Bilder
 * und Videos. Eingefügte Bilder entstehen damit gar nicht erst; netz-services entfernt sie
 * zusätzlich beim Speichern.
 */
export const APP_NEWS_QUILL_FORMATS = [
  'bold',
  'italic',
  'underline',
  'strike',
  'header',
  'list',
  'script',
  'indent',
  'align',
  'color',
  'background',
  'link'
];
